export default "__VITE_ASSET__964a1f8c__"